import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

interface ExportCsvPayload {
	filename: string
	exportFn: () => Promise<Blob>
}

export function useMutationExportPlayerCsv() {
	return useMutation({
		mutationFn: async ({ exportFn }: ExportCsvPayload) => {
			return await exportFn()
		},
		onSuccess: (blob, variables) => {
			// Create download link
			const url = window.URL.createObjectURL(blob)
			const link = document.createElement('a')
			link.href = url

			// Set filename
			const filename = variables.filename || 'export'
			link.download = `${filename}.csv`

			// Trigger download
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)

			// Clean up
			window.URL.revokeObjectURL(url)

			toast.success('ดาวน์โหลดไฟล์ CSV สำเร็จ')
		},
		onError: (error) => {
			console.error('CSV export error:', error)
			toast.error('การดาวน์โหลดไฟล์ CSV ล้มเหลว กรุณาลองใหม่อีกครั้ง')
		},
	})
}
